const fromArray = (
  // timestamp in format: 00:01.000 --> 00:25.000
  arr: Array<{ timestamp: string; text: string }>,
) => {
  return arr.reduce<string>((acc, curr, index) => {
    return acc + `${index + 1}\n${formatSrtStringFromRow(curr)}`;
  }, '');
};

const formatSrtStringFromRow = (row: { timestamp: string; text: string }) => {
  return `${row.timestamp}\n${row.text.replaceAll('\\N', '\n')}\n\n`;
};

const download = (arr: Array<{ timestamp: string; text: string }>) => {
  const content = 'data:text/plain;charset=utf-8,' + fromArray(arr);
  const encodedUri = encodeURI(content);
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', 'subtitles.srt');
  document.body.appendChild(link);
  link.click();
  link.remove();
};

const srt = {
  fromArray,
  download,
};

export default srt;
